import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c9019dd6&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "bulma/css/bulma.css?vue&type=style&index=0&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=c9019dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9019dd6",
  null
  
)

export default component.exports